import React from "react";
import { ILocalizationContext } from "../Types";

export const LocalizationContext = React.createContext<ILocalizationContext>({} as ILocalizationContext);
LocalizationContext.displayName = 'Cutlio localization context';

export function useLocalizationContext() {
  return React.useContext(LocalizationContext);
}
